import { Icon } from "@blueprintjs/core"
import React from "react"

import { sessionStore } from "~/store/hasura"

import Button from "~/common/buttons/Button"

import { showToast } from "~/containers/ToasterContainer"

const CopyToSuperuserTestAccountAction = () => {
  const handleCopyToSuperuserTestAccount = async () => {
    const confirmed = confirm(
      "Are you sure you want to override the superuser's test account with a copy of the current account? \nThis action can not be undone.",
    )
    if (!confirmed) {
      return
    }

    try {
      const hasuraAuthToken = await sessionStore.getAuthToken()
      const nodeServerEndpoint = await sessionStore.getNodeServerEndpoint()

      const response = await fetch(
        `${nodeServerEndpoint}/account/copy-to-superuser-test-account`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${hasuraAuthToken}`,
          },
        },
      )

      if (response.ok) {
        window.location.href = "/"
      } else {
        showToast({
          message: "Failed to copy account to superuser test account",
          type: "error",
        })
      }
    } catch (error) {
      showToast({
        message: "Failed to copy account to superuser test account",
        type: "error",
      })
    }
  }

  return (
    <Button
      text="Copy Account to Superuser Test Account"
      onClick={handleCopyToSuperuserTestAccount}
      icon={<Icon icon="add" size={14} />}
      style={{ padding: "0 6px" }}
    />
  )
}

export default CopyToSuperuserTestAccountAction
